<template>
    <flex-element :element-type="elementType" class="fc-icon f-flex f-items-center f-cursor-pointer">
        <a-link
            :class-default="classTextDefault"
            v-bind="element(1)"
            @element-updated="elementUpdated"
        >
            <slot />
        </a-link>

        <a-icon
            class="fc-icon__arrow"
            :class-default="`f-ml-0.5 ${ classIconDefault }`"
            :icon-default="iconDefault"
            :set-default="setDefault"
            v-bind="element(2)"
            @element-updated="elementUpdated"
        />
    </flex-element>
</template>

<script>
import Organism from '@/mixins/base-organism/base-organism-smart';

export default {
    mixins: [Organism],

    props: {
        displayName: {
            type: String,
            default: 'Arrow Link',
        },

        classTextDefault: {
            type: String,
            default: '',
        },

        classIconDefault: {
            type: String,
            default: '',
        },

        iconDefault: {
            type: String,
            default: 'long-arrow-right',
        },

        setDefault: {
            type: String,
            default: 'fal',
        },
    },
};
</script>

<style lang="scss" scoped>
.fc-icon {
    $this: &;

    &__arrow {
        transition: all 0.3s ease;

        #{ $this }:hover & {
            transform: translateX(8px);
        }
    }
}
</style>
